var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-headBg"},[_c('HeadSticky',{ref:"headSearch",attrs:{"hasLogin":_vm.routerName !== 'login'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }